module.exports = __webpack_public_path__ + "static/media/ZM_Vehicle_Docs.faad0cef.pdf";